import React from "react"
const PasswordRequirements = ({ passwordRegExp = {}, i18n = {} }) => {
  const {
    pwMustInclude = "",
    characterCount = "",
    uppercaseLetter = "",
    lowercaseLetter = "",
    symbolValidation = "",
    numberValidation = "",
  } = i18n
  return (
    <div className="password-tooltip" id="reset-password__req-toottip">
      <p>{pwMustInclude}</p>
      <ul>
        {passwordRegExp?.passwordMessage?.length ? (
          passwordRegExp?.passwordMessage.map(message => (
            <li key={message}>{message}</li>
          ))
        ) : (
          <>
            <li>{characterCount}</li>
            <li>{uppercaseLetter}</li>
            <li>{lowercaseLetter}</li>
            <li>{symbolValidation}</li>
            <li>{numberValidation}</li>
          </>
        )}
      </ul>
    </div>
  )
}

export default PasswordRequirements
